import React, { useEffect } from "react"
import gsap from "gsap"

const MapAnimation = () => {
	const iconAnim = (icon) => {
		let tl = gsap.timeline();

		tl.to(icon, { opacity: 1, duration: 1, ease: "power2.out"})
		tl.to(icon, { opacity: 0, duration: 0.5, ease: "power2.out", delay: 3.5})

		return tl;
	}

	const linesAnim = (icon) => {
		let tl = gsap.timeline();

		tl.fromTo(`${icon} > .ring1`, {scale: 1, opacity: 0}, {scale: 1.3, opacity: 1, duration: 2, ease: "power2.out"})
		tl.fromTo(`${icon} > .ring2`, {scale: 1.1, opacity: 0}, {scale: 1.6, opacity: 1, duration: 2, ease: "power2.out"}, "<")
		tl.fromTo(`${icon} > .ring3`, {scale: 1.1, opacity: 0}, {scale: 1.4,opacity: 1, duration: 1.8, ease: "power2.out"}, "<")
		tl.to([`${icon} > .ring1`, `${icon} > .ring2`, `${icon} > .ring3`], {opacity: 0, duration: 0.5, ease: "power2.out"})
		tl.fromTo(`${icon} > .ring1`, {scale: 1, opacity: 0}, {scale: 1.3, opacity: 1, duration: 2, ease: "power2.out"})
		tl.fromTo(`${icon} > .ring2`, {scale: 1.1, opacity: 0}, {scale: 1.6, opacity: 1, duration: 2, ease: "power2.out"}, "<")
		tl.fromTo(`${icon} > .ring3`, {scale: 1.1, opacity: 0}, {scale: 1.95,opacity: 1, duration: 2, ease: "power2.out"}, "<")

		return tl;
	}

	useEffect(() => {
		if (typeof window == "undefined" || window.parent.location !== window.location) {
		  // You are in Draft Mode or in the Visual Editor. Skip animation.
		  return
		}
	
		let master = gsap.timeline({
			scrollTrigger: {
				trigger: (".gs_reveal .map_animation"),
				start: "top bottom"
			}
		});

		master
		.add(iconAnim(".political"))
		.add(linesAnim(".political"), "<")
		.add(iconAnim(".military"))
		.add(linesAnim(".military"), "<")
		.add(iconAnim(".economic"))
		.add(linesAnim(".economic"), "<")
		.add(iconAnim(".social"))
		.add(linesAnim(".social"), "<")
		.add(iconAnim(".information"))
		.add(linesAnim(".information"), "<")
		.add(iconAnim(".infrastructure"))
		.add(linesAnim(".infrastructure"), "<")
	  	.add(iconAnim(".physical_env"))
		.add(linesAnim(".physical_env"), "<")
		.repeat(-1)
	})

	return (
		<div className="component map_animation">
			<div className="political icon" style={{backgroundImage:'url(https://a.storyblok.com/f/192434/189x180/31d6ede5dd/political.svg)'}}>
				<div className="ring1"></div>
				<div className="ring2"></div>
				<div className="ring3"></div>
			</div>

			<div className="military icon" style={{backgroundImage : 'url(https://a.storyblok.com/f/192434/189x180/7e17eef549/military.svg)'}}>
				<div className="ring1"></div>
				<div className="ring2"></div>
				<div className="ring3"></div>
			</div>

			<div className="economic icon" style={{backgroundImage : 'url(https://a.storyblok.com/f/192434/189x180/9cfa552be3/economic.svg)'}}>
				<div className="ring1"></div>
				<div className="ring2"></div>
				<div className="ring3"></div>
			</div>

			<div className="social icon" style={{backgroundImage : 'url(https://a.storyblok.com/f/192434/189x180/edbb07a05c/social.svg)'}}>
				<div className="ring1"></div>
				<div className="ring2"></div>
				<div className="ring3"></div>
			</div>

			<div className="information icon" style={{backgroundImage : 'url(https://a.storyblok.com/f/192434/189x180/d6ec0c1a63/information.svg)'}}>
				<div className="ring1"></div>
				<div className="ring2"></div>
				<div className="ring3"></div>
			</div>

			<div className="infrastructure icon" style={{backgroundImage : 'url(https://a.storyblok.com/f/192434/189x180/706b07b3d8/infrastructure.svg)'}}>
				<div className="ring1"></div>
				<div className="ring2"></div>
				<div className="ring3"></div>
			</div>

			<div className="physical_env icon" style={{backgroundImage : 'url(https://a.storyblok.com/f/192434/189x180/1520b90615/physical_env.svg)'}}>
				<div className="ring1"></div>
				<div className="ring2"></div>
				<div className="ring3"></div>
			</div>

			<img className="map" alt="World Map" src="https://a.storyblok.com/f/192434/1085x565/aff8aa344d/worldmap.svg" loading="lazy"/> 
		</div>
	)
}

export default MapAnimation